export default __webpack_public_path__ + "ae7792ee024e3e6b2053a70534120d29.svg";